export default "__VITE_ASSET__iIzzValF__";